import React from 'react'

import {Link} from 'react-router-dom' 

const Footer = () => {
    return (
        <footer className="site-footer">
            <div className="container">
                <div className="row gap-y align-items-center">
                <div className="col-12 col-lg-6 offset-lg-3">
                    <ul className="nav nav-primary nav-hero">
                    <li className="nav-item">
                        <div className="text-center">
                        <Link className="nav-link" to="/about">PAULO YMAMURA</Link>
                        <p>Licenciado CRECI 45101</p>
                        </div>
                     
                    </li>
                    </ul>
                </div>
                </div>
            </div>
        </footer>

    );
};

export default Footer;


// WEBPACK FOOTER //
// ./src/common/Footer/index.jsx